// imports
import {
  WriteContractResult,
  prepareWriteContract,
  readContract as readWagmiContract,
  writeContract as writeWagmiContract,
  watchContractEvent as watchWagmiContractEvent
} from 'wagmi/actions';
import { IContractProps, Listener } from './types';

// exports
export function readContract(props: IContractProps): Promise<unknown> {
  const {
    abi, args, chainId, address, functionName
  } = props;
  return readWagmiContract({
    args,
    chainId,
    abi: abi!,
    address: address!,
    functionName: functionName!
  });
}

export function writeContract(props: IContractProps): Promise<WriteContractResult | null> {
  const {
    abi, args, chainId, address, functionName
  } = props;
  return prepareWriteContract({
    args,
    chainId,
    abi: abi!,
    address: address!,
    functionName: functionName!
  }).then((config) => writeWagmiContract(config.request));
}

export function watchContractEvent(props: IContractProps): () => void {
  const {
    abi, args, address, functionName
  } = props;
  const listener = args![0] as Listener;
  const unwatch = watchWagmiContractEvent({
    abi: abi!,
    address: address!,
    eventName: functionName!
  }, listener);
  return unwatch;
}

// exports - default
export default {
  readContract,
  watchContractEvent
};
